import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { bulkUpdateDealerCredentials, resetAlert } from "../store/addDealerCredentials/actions";
import * as XLSX from "xlsx";
import DataTable from 'react-data-table-component';

const BulkUploadTMobilePassword = (props) => {
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    setTableData([]);
    setColumns([]);
    setError("");
  }, []);

  useEffect(() => {
    if (props.bulkUpdatemessage) {
      props.back();
      setTimeout(() => {
        dispatch(resetAlert());
      }, 2000);
    }
  }, [props.bulkUpdatemessage])


  const REQUIRED_COLUMNS = [
    "DealerID",
    "DealerName",
    "ChannelName",
    "NewUsername",
    "NewPassword",
    "EmployeeID",
  ];

  const handleFileChange = (e) => {
    setError("");
    const file = e.target.files[0];
    if (!file) {
      setError("Please upload an Excel file");
      return;
    }
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (fileExtension !== "xlsx") {
      setError("Only Excel (.xlsx) file is allowed");
      e.target.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      if (!jsonData || jsonData.length === 0) {
        setError("Excel file is empty");
        return;
      }

      const excelHeaders = jsonData[0];
      const rows = jsonData.slice(1);

      const missingColumns = REQUIRED_COLUMNS.filter(
        (col) => !excelHeaders.includes(col)
      );

      if (missingColumns.length > 0) {
        setError(
          `Missing required columns: ${missingColumns.join(", ")}`
        );
        return;
      }
      if (rows.length === 0) {
        setError("Excel file is empty");
        return;
      }

      const hasAnyData = rows.some((row) =>
        row?.some(
          (cell) => cell !== undefined && cell !== null && cell.toString().trim() !== "")
      );

      if (!hasAnyData) {
        setError("Excel file is empty");
        return;
      }
      setError("");
      const formattedData = rows.map((row) => {
        let obj = {};
        excelHeaders.forEach((header, index) => {
          obj[header] = row[index] ?? "";
        });
        return obj;
      });

      const tableColumns = excelHeaders.map((header) => ({
        name: header,
        selector: (row) => row[header],
        sortable: true,
        wrap: true,
      }));
      setColumns(tableColumns);
      setTableData(formattedData);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleUpdate = () => {
    if (tableData.length === 0) {
      setError("No data to submit");
      return;
    }
    const updatedData = Array.isArray(tableData) ? tableData.map(row => ({
      DealerID: row.DealerID,
      NewUsername: row.NewUsername,
      NewPassword: String(row.NewPassword ?? ""),
      EmployeeID: row.EmployeeID
    })) : [];
    dispatch(bulkUpdateDealerCredentials(updatedData));
  };

  return (
    <div className="nk-block-head-content">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }} >
        <h3 className="nk-block-title page-title">Bulk Upload T-Mobile Password</h3>
      </div>
      <div className="card p-2">
        {props.bulkUpdateError &&
          <div className="alert alert-danger alert-icon"><em className="icon ni ni-cross-circle"></em> <strong>{props.bulkUpdateError}</strong></div>}
        <div className="card-inner p-0">
          <div className="row align-items-start mb-3">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="excelFile"> Upload File </label>
                <input type="file" className="form-control" id="excelFile" accept=".xlsx" onChange={handleFileChange} />
                {error && (
                  <div className="text-danger mt-1" style={{ fontSize: "13px" }}> {error} </div>
                )}
              </div>
            </div>

            <div className="col-sm-6 d-flex justify-content-end">
              <button type="button" onClick={() => props.back()} className="btn btn-danger mt-4" > <em className="icon ni ni-arrow-left"></em> Back </button>
            </div>
          </div>
        </div>
      </div>

      {tableData.length > 0 && (
        <div className="card mt-3">
          <div className="card-inner">
            <h6 className="mb-2">Uploaded File Preview</h6>

            <DataTable
              columns={columns}
              data={tableData}
              striped
              responsive
              highlightOnHover
            />

            <div className="d-flex justify-content-end mt-3">
              <button type='submit' className="btn btn-primary" disabled={props.bulkUpdateloading} style={{ marginTop: '1.9rem' }} onClick={handleUpdate} >
                {props.bulkUpdateloading && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
                <span>Update</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
const mapStateToProps = (state) => {
  const { channelData, dealerData } = state.dealer;
  const { bulkUpdatemessage, bulkUpdateError, bulkUpdateloading } = state.addDealerCredentials;
  return { channelData, dealerData, bulkUpdatemessage, bulkUpdateError, bulkUpdateloading };
};

export default withRouter(connect(mapStateToProps, { bulkUpdateDealerCredentials, resetAlert })(BulkUploadTMobilePassword));
